import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from '@/utils/mixin.js';
export default {
  name: "Footer",
  mixins: [mixinDevice],
  data: function data() {
    return {
      year: new Date().getFullYear(),
      tenantInfo: {}
    };
  },
  created: function created() {
    this.tenantInfo = Vue.ls.get(TENANT_CONFIG);
  }
};